import { TODO, UIBModal } from '@b2b/types/core';
import angular, { IScope } from 'angular';

export const TemplatesCreateSchedulesCreateFormsModalsCreateControllerModule = angular
  .module('acme.view.application.templates.create.schedules.create.forms.modals.create.controllers', [
    'ui.bootstrap',
    'acme.common.service.validate',
  ])
  .controller('TemplatesCreateSchedulesCreateFormsModalsCreateController', [
    '$scope',
    '$uibModalInstance',
    'ValidateService',
    function TemplatesCreateSchedulesCreateFormsModalsCreateController(
      $scope: IScope & { templatesCreateSchedulesCreateFormsModalsCreate: TODO },
      $uibModalInstance: UIBModal<TODO>,
      ValidateService: TODO
    ) {
      $scope.templatesCreateSchedulesCreateFormsModalsCreate = {
        title: 'Create Form',
        model: {
          name: '',
        },

        validators: [],
        errors: [],
        notice: {
          name: 'Form name is required',
        },

        init: function () {
          const self = $scope.templatesCreateSchedulesCreateFormsModalsCreate;
          self.validators.push({ len: { value: this.model.name } });
        },

        done: function () {
          const self = $scope.templatesCreateSchedulesCreateFormsModalsCreate;
          const test = { len: { value: self.model.name } };
          self.isSubmitted = true;
          if (ValidateService.validate(test)) {
            $uibModalInstance.close({
              name: this.model.name,
              description: this.model.description,
            });
          } else {
            self.errors = [{ message: 'Please correct the errors below' }];
          }
        },

        isValidFormName: function () {
          if (this.isSubmitted) {
            return ValidateService.validate([{ len: { value: this.model.name } }]);
          }

          return true;
        },

        cancel: function () {
          $uibModalInstance.dismiss('cancel');
        },

        success: {
          init: function (response) {},
        },

        error: {
          init: function (response) {},
        },
      };

      $scope.templatesCreateSchedulesCreateFormsModalsCreate.init();
    },
  ]).name;
